import { render, staticRenderFns } from "./split-pane.vue?vue&type=template&id=a85f7310&"
import script from "./split-pane.vue?vue&type=script&lang=js&"
export * from "./split-pane.vue?vue&type=script&lang=js&"
import style0 from "./split-pane.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "split-pane.vue"
export default component.exports